module.exports = __webpack_public_path__ + "static/media/Escudo_L.e6236d15.png";